import { IManagedColumn } from '@starryui10/grids/buttonBar/ManageColumnButton';
import { ModuleLayout } from '@starryui10/layouts/moduleLayout';
import { ModuleLoading } from '@starryui10/Loading/ModuleLoading';
import React, { createRef } from 'react';
import { useEntryDirectoryEvents } from '../../context/EntryDirectoryContext';
import { strings } from '../../localization';
import { EntrySearch } from '../../popups/EntrySearch';
import { useDirectoryState } from '../../state/DirectoryState';
import { AppButtonBar } from './AppButtonBar';
import { Caption } from './Caption';
import { ColumnsProvider } from './ColumnsProvider';
import { FilterControls } from './FilterControls';
import { Grid, IGridRefs } from './Grid';
import { Loading } from './Loading';
import { SubCaption } from './SubCaption';

export const App = () => {
    const { initialLoading } = useDirectoryState();
    const { newEntry } = useEntryDirectoryEvents();
    
    const gridRef = createRef<IGridRefs>();

    const handleNewEntry = () => {
        newEntry();
    };

    const handleColumnToggle = (col: IManagedColumn) => {
        gridRef.current?.toggleColumn(col);
    };

    return initialLoading ? (
        <ModuleLoading />
    ) : (
        <ColumnsProvider>
            <ModuleLayout
                caption={<Caption />}
                subCaption={<SubCaption />}
                buttonBar={<AppButtonBar onColumnToggle={handleColumnToggle} />}
                newButtonCaption={strings.MainDirectory_Label_NewEntry}
                onNewButtonClick={handleNewEntry}
                filterControls={<FilterControls />}
            >
                {({ height }) => <Grid ref={gridRef} height={height} />}
            </ModuleLayout>
            
            <Loading />
            <EntrySearch />

        </ColumnsProvider>
    );
};
